import { SHButton, SHDialog, SHStack } from "@components/design-systems";

interface SaveProgressWarningDialogProps {
  open: boolean;
  onDiscard?: () => void;
  onReturn?: () => void;
}
export const SaveProgressWarningDialog = ({
  open,
  onDiscard,
  onReturn,
}: SaveProgressWarningDialogProps) => {
  return (
    <SHDialog
      maxWidth="sm"
      width={400}
      open={open}
      header={
        "You have unsaved changes"
        // <SHStack alignItems="center" textAlign={"center"}>
        //   <SHTypography variant="h2" lineHeight={"120%"} width={"70%"}>
        //     To save progress, each platform must have a valid portfolio
        //   </SHTypography>
        // </SHStack>
      }
      body={
        "Would you like to discard them?"
        // <SHStack alignItems="center" textAlign={"center"} gap={2}>
        //   <SHTypography variant="body2">
        //     Some platforms in your analysis do not have a valid portfolio
        //     assigned to them. Each platform must have a portfolio.
        //   </SHTypography>
        //   <SHTypography variant="body2">
        //     If you go back or exit, you will lose the data already entered into
        //     the fee calculator. Would you like to discard them?
        //   </SHTypography>
        // </SHStack>
      }
      footer={
        <SHStack
          justifyContent="center"
          alignItems="center"
          direction={"row"}
          spacing={7}
        >
          <SHButton
            color="secondary"
            variant="text"
            size="extraMedium"
            onClick={onDiscard}
          >
            Discard
          </SHButton>
          <SHButton
            color="primary"
            variant="contained"
            size="extraMedium"
            onClick={onReturn}
          >
            Keep editing
          </SHButton>
        </SHStack>
      }
    />
  );
};
